"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@chakra-ui/react");
var _options = _interopRequireDefault(require("./options"));
var _Text = require("./Text.styles");
var _combineAsWithVariant = _interopRequireDefault(require("./combineAsWithVariant"));
var _excluded = ["as", "variant"];
var Text = (0, _react2.forwardRef)(function (_ref, ref) {
  var as = _ref.as,
    variant = _ref.variant,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react2.Text, (0, _extends2["default"])({
    variant: variant,
    as: as
  }, (0, _combineAsWithVariant["default"])({
    as: as,
    variant: variant
  }), props, {
    ref: ref
  }));
});
Text.defaultProps = {
  as: 'p',
  variant: 'body'
};
var _default = exports["default"] = Text;